import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';

export class VacancyPeriod extends ModelBase {
  constructor() {
    super();
    Object.defineProperties(this, {
      _fromDate: { enumerable: false, writable: true },
      _toDate: { enumerable: false, writable: true },
    });
  }

  private _fromDate: LocalDate;
  private _toDate: LocalDate;

  get fromDate(): LocalDate {
    return this._fromDate;
  }
  set fromDate(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }

  get toDate(): LocalDate {
    return this._toDate;
  }
  set toDate(value: LocalDate) {
    this._toDate = LocalDate.fromDate(value);
  }

  rentLossCurrentYear: Money;
}
